import type { IInShiftTaskTemplate } from '@shiftsmartinc/shiftsmart-types';

import BaseStore from './_baseStore';

export default class InShiftTaskTemplatesStore extends BaseStore<IInShiftTaskTemplate> {
  constructor() {
    super({
      baseItem: InShiftTaskTemplatesStore.BASE_ITEM,
      serviceName: 'inShiftTaskTemplates',
    });

    return this;
  }

  static BASE_ITEM: IInShiftTaskTemplate = {
    companyId: null,
    createdAt: null,
    modelName: null,
    settings: null,
    title: null,
    updatedAt: null,
    uuid: null,
  };
}
